'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrefixTextStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  /**
   * Full-width TextField doesn't have borders
   */
  fullWidth: _propTypes2.default.bool,

  /**
   * If textfield is dense it has smaller paddings
   */
  dense: _propTypes2.default.bool,

  /**
   * Define component theme config
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};
var defaultProps = {
  fullWidth: false,
  dense: false
};
/** PROP RECEIVERS */

var baseProps = function baseProps(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var lineHeight = theme.reactackle.components.textfield.prefix.lineHeight;
  return '\n    line-height: ' + lineHeight + ';\n  ';
};

var sizeProps = function sizeProps(_ref2) {
  var dense = _ref2.dense,
      fullWidth = _ref2.fullWidth,
      themeFromProvider = _ref2.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.textfield.prefix.size;
  var source = null;
  if (dense && !fullWidth) source = path.dense;else if (dense && fullWidth) source = path.denseFullWidth;else if (!dense && fullWidth) source = path.fullWidth;else source = path;
  var _source = source,
      fontSize = _source.fontSize,
      paddingY = _source.paddingY,
      prefixSpacing = _source.prefixSpacing;
  return (0, _styledComponents.css)(['font-size:', ';padding:', ' 0;padding-right:', ';'], (0, _reactackleCore.getValueString)(fontSize), (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(prefixSpacing));
};
/** STYLES */


var PrefixTextStyled = exports.PrefixTextStyled = _styledComponents2.default.span.withConfig({
  displayName: 'PrefixTextStyled'
})(['display:flex;align-items:center;color:inherit;', ';', ';', ';'], baseProps, sizeProps, (0, _reactackleCore.transition)('color'));

PrefixTextStyled.propTypes = propTypes;
PrefixTextStyled.defaultProps = defaultProps;
PrefixTextStyled.displayName = 'PrefixTextStyled';